// Свой приз в розыгрыше сервер зачисляет в момент объявления места; баланс в шапке приложения нужно
// обновить один раз за розыгрыш — общим счётом для экрана «Розыгрыш» и баннера на главном:
// - смотрел эфир и увидел объявление своего места — праздник, приз прибавляется к балансу (updateMoney);
// - увидел своё место уже объявленным (открыл экран позже, баннер на главном) — тихо обновить баланс
//   с сервера (refreshInfo), чуть позже: начисление идёт в момент объявления, ему нужно мгновение.
const handled = {};

export function prizeHandled(day) {
    return !!handled[day];
}

export function markPrizeHandled(day) {
    handled[day] = true;
}

export function syncPrizeBalance(day, refreshInfo) {
    if (handled[day] || typeof refreshInfo !== 'function') return;
    handled[day] = true;
    setTimeout(refreshInfo, 2500);
}
